// extracted by mini-css-extract-plugin
export default {"password_wrapper":"sign-in_password_wrapper__aLUTC","forgot_password":"sign-in_forgot_password__tLpAa"};